var _get = require("/Users/volkram/Downloads/mandy 240124/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _assertThisInitialized = require("/Users/volkram/Downloads/mandy 240124/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _classCallCheck = require("/Users/volkram/Downloads/mandy 240124/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/volkram/Downloads/mandy 240124/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/volkram/Downloads/mandy 240124/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/volkram/Downloads/mandy 240124/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/volkram/Downloads/mandy 240124/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('react')) : typeof define === 'function' && define.amd ? define(['exports', 'react'], factory) : factory(global.easyState = {}, global.react);
})(this, function (exports, react) {
  'use strict';

  var promise = Promise.resolve(); // schedule the given task as a microtask
  // (this used to leak into after the next task when mixed with MutationObservers in Safari)

  function nextTick(task) {
    return promise.then(task);
  }

  var proxyToRaw = new WeakMap();
  var rawToProxy = new WeakMap();
  var ITERATE = Symbol('iterate');
  var getPrototypeOf = Object.getPrototypeOf;

  function has(value) {
    var rawContext = proxyToRaw.get(this);
    var proto = getPrototypeOf(this);

    if (!rawContext) {
      return proto.has.apply(this, arguments);
    }

    registerRunningReactionForKey(rawContext, value);
    return proto.has.apply(rawContext, arguments);
  }

  function get$1(key) {
    var rawContext = proxyToRaw.get(this);
    var proto = getPrototypeOf(this);

    if (!rawContext) {
      return proto.get.apply(this, arguments);
    }

    registerRunningReactionForKey(rawContext, key);
    return proto.get.apply(rawContext, arguments);
  }

  function add(value) {
    var rawContext = proxyToRaw.get(this);
    var proto = getPrototypeOf(this);

    if (!rawContext) {
      return proto.add.apply(this, arguments);
    }

    if (!proto.has.call(rawContext, value)) {
      queueReactionsForKey(rawContext, value);
      queueReactionsForKey(rawContext, ITERATE);
    }

    return proto.add.apply(rawContext, arguments);
  }

  function set$1(key, value) {
    var rawContext = proxyToRaw.get(this);
    var proto = getPrototypeOf(this);

    if (!rawContext) {
      return proto.set.apply(this, arguments);
    }

    if (proto.get.call(rawContext, key) !== value) {
      queueReactionsForKey(rawContext, key);
      queueReactionsForKey(rawContext, ITERATE);
    }

    return proto.set.apply(rawContext, arguments);
  }

  function deleteFn(value) {
    var rawContext = proxyToRaw.get(this);
    var proto = getPrototypeOf(this);

    if (!rawContext) {
      return proto.delete.apply(this, arguments);
    }

    if (proto.has.call(rawContext, value)) {
      queueReactionsForKey(rawContext, value);
      queueReactionsForKey(rawContext, ITERATE);
    }

    return proto.delete.apply(rawContext, arguments);
  }

  function clear() {
    var rawContext = proxyToRaw.get(this);
    var proto = getPrototypeOf(this);

    if (!rawContext) {
      return proto.clear.apply(this, arguments);
    }

    if (rawContext.size) {
      queueReactionsForKey(rawContext, ITERATE);
    }

    return proto.clear.apply(rawContext, arguments);
  }

  function forEach() {
    var rawContext = proxyToRaw.get(this);
    var proto = getPrototypeOf(this);

    if (!rawContext) {
      return proto.forEach.apply(this, arguments);
    }

    registerRunningReactionForKey(rawContext, ITERATE);
    return proto.forEach.apply(rawContext, arguments);
  }

  function keys() {
    var rawContext = proxyToRaw.get(this);
    var proto = getPrototypeOf(this);

    if (!rawContext) {
      return proto.keys.apply(this, arguments);
    }

    registerRunningReactionForKey(rawContext, ITERATE);
    return proto.keys.apply(rawContext, arguments);
  }

  function values() {
    var rawContext = proxyToRaw.get(this);
    var proto = getPrototypeOf(this);

    if (!rawContext) {
      return proto.values.apply(this, arguments);
    }

    registerRunningReactionForKey(rawContext, ITERATE);
    return proto.values.apply(rawContext, arguments);
  }

  function entries() {
    var rawContext = proxyToRaw.get(this);
    var proto = getPrototypeOf(this);

    if (!rawContext) {
      return proto.entries.apply(this, arguments);
    }

    registerRunningReactionForKey(rawContext, ITERATE);
    return proto.entries.apply(rawContext, arguments);
  }

  function iterator() {
    var rawContext = proxyToRaw.get(this);
    var proto = getPrototypeOf(this);

    if (!rawContext) {
      return proto[Symbol.iterator].apply(this, arguments);
    }

    registerRunningReactionForKey(rawContext, ITERATE);
    return proto[Symbol.iterator].apply(rawContext, arguments);
  }

  function getSize() {
    var rawContext = proxyToRaw.get(this);
    var proto = getPrototypeOf(this);

    if (!rawContext) {
      return Reflect.get(proto, 'size', this);
    }

    registerRunningReactionForKey(rawContext, ITERATE);
    return Reflect.get(proto, 'size', rawContext);
  }

  function instrumentMap(map) {
    map.has = has;
    map.get = get$1;
    map.set = set$1;
    map.delete = deleteFn;
    map.clear = clear;
    map.forEach = forEach;
    map.keys = keys;
    map.values = values;
    map.entries = entries;
    map[Symbol.iterator] = iterator;
    Object.defineProperty(map, 'size', {
      get: getSize
    });
  }

  function instrumentSet(set) {
    set.has = has;
    set.add = add;
    set.delete = deleteFn;
    set.clear = clear;
    set.forEach = forEach;
    set.keys = keys;
    set.values = values;
    set.entries = entries;
    set[Symbol.iterator] = iterator;
    Object.defineProperty(set, 'size', {
      get: getSize
    });
  }

  function instrumentWeakMap(map) {
    map.has = has;
    map.get = get$1;
    map.set = set$1;
    map.delete = deleteFn;
  }

  function instrumentWeakSet(set) {
    set.has = has;
    set.add = add;
    set.delete = deleteFn;
  } // built-in object can not be wrapped by Proxies
  // their methods expect the object instance as the 'this' and when a Proxy instance is passed instead they break
  // simple objects are not wrapped by Proxies or instrumented
  // complex objects are wrapped and their methods are monkey patched
  // to switch the proxy to the raw object and to add reactive wiring


  var instrumentations = new Map([[Map.prototype, instrumentMap], [Set.prototype, instrumentSet], [WeakMap.prototype, instrumentWeakMap], [WeakSet.prototype, instrumentWeakSet], [Date.prototype, false], [RegExp.prototype, false]]);
  var connectionStore = new WeakMap();
  var cleanupStore = new WeakMap();

  function storeObservable(obj) {
    // this will be used to save (obj.key -> reaction) connections later
    connectionStore.set(obj, Object.create(null));
  }

  function storeReaction(reaction) {
    // this will be used to save data for cleaning up later
    cleanupStore.set(reaction, new Set());
  }

  function registerReactionForKey(obj, key, reaction) {
    var reactionsForObj = connectionStore.get(obj);
    var reactionsForKey = reactionsForObj[key];

    if (!reactionsForKey) {
      reactionsForObj[key] = reactionsForKey = new Set();
    }

    reactionsForKey.add(reaction);
    cleanupStore.get(reaction).add(reactionsForKey);
  }

  function iterateReactionsForKey(obj, key, fn) {
    var reactionsForKey = connectionStore.get(obj)[key];

    if (reactionsForKey) {
      reactionsForKey.forEach(fn);
    }
  }

  function releaseReaction(reaction) {
    cleanupStore.get(reaction).forEach(releaseReactionKeyConnections, reaction);
  }

  function releaseReactionKeyConnections(reactionsForKey) {
    reactionsForKey.delete(this);
  }

  var ENUMERATE = Symbol('enumerate');
  var queuedReactions = new Set();
  var runningReaction;
  var handlers = {
    get: get,
    ownKeys: ownKeys,
    set: set,
    deleteProperty: deleteProperty
  };

  function observe(reaction) {
    if (typeof reaction !== 'function') {
      throw new TypeError('Reactions must be functions.');
    } // init basic data structures to save and cleanup (observable.prop -> reaction) connections later


    storeReaction(reaction); // run the reaction once to discover what observable properties it uses

    runReaction(reaction);
    return reaction;
  }

  function unobserve(reaction) {
    // do not run this reaction anymore, even if it is already queued
    queuedReactions.delete(reaction); // release every (observable.prop -> reaction) connections

    releaseReaction(reaction);
  }

  function observable(obj) {
    obj = obj || {};

    if (typeof obj !== 'object') {
      throw new TypeError('First argument must be an object or undefined');
    } // if it is already an observable, return it


    if (proxyToRaw.has(obj)) {
      return obj;
    }

    return (// if it already has a cached observable wrapper, return it
      // if it is a special built-in object, instrument it then wrap it with an observable
      // otherwise simply wrap the object with an observable
      rawToProxy.get(obj) || instrumentObservable(obj) || createObservable(obj)
    );
  }

  function instrumentObservable(obj) {
    var instrument = instrumentations.get(Object.getPrototypeOf(obj)); // these objects break, when they are wrapped with proxies

    if (instrument === false) {
      return obj;
    } // these objects can be wrapped by Proxies, but require special instrumentation beforehand


    if (typeof instrument === 'function') {
      instrument(obj);
    }
  } // wrap the object in a Proxy and save the obj-proxy, proxy-obj pairs


  function createObservable(obj) {
    var observable = new Proxy(obj, handlers); // init basic data structures to save and cleanup later (observable.prop -> reaction) connections

    storeObservable(obj); // save these to switch between the raw object and the wrapped object with ease later

    proxyToRaw.set(observable, obj);
    rawToProxy.set(obj, observable);
    return observable;
  } // intercept get operations on observables to know which reaction uses their properties


  function get(obj, key, receiver) {
    // make sure to use the raw object here
    var rawObj = proxyToRaw.get(obj) || obj; // expose the raw object on observable.$raw

    if (key === '$raw') {
      return rawObj;
    }

    var result = Reflect.get(obj, key, receiver); // do not register (observable.prop -> reaction) pairs for these cases

    if (typeof key === 'symbol' || typeof result === 'function') {
      return result;
    } // register and save (observable.prop -> runningReaction)


    registerRunningReactionForKey(rawObj, key); // if we are inside a reaction and observable.prop is an object wrap it in an observable too
    // this is needed to intercept property access on that object too (dynamic observable tree)

    if (runningReaction && typeof result === 'object' && result !== null) {
      return observable(result);
    } // otherwise return the observable wrapper if it is already created and cached or the raw object


    return rawToProxy.get(result) || result;
  }

  function ownKeys(obj) {
    registerRunningReactionForKey(obj, ENUMERATE);
    return Reflect.ownKeys(obj);
  } // register the currently running reaction to be queued again on obj.key mutations


  function registerRunningReactionForKey(obj, key) {
    if (runningReaction) {
      registerReactionForKey(obj, key, runningReaction);
    }
  } // intercept set operations on observables to know when to trigger reactions


  function set(obj, key, value, receiver) {
    // make sure to do not pollute the raw object with observables
    if (typeof value === 'object' && value !== null) {
      value = proxyToRaw.get(value) || value;
    } // do not register reactions if it is a symbol keyed property
    // or if the target of the operation is not the raw object (possible because of prototypal inheritance)


    if (typeof key === 'symbol' || obj !== proxyToRaw.get(receiver)) {
      return Reflect.set(obj, key, value, receiver);
    } // only queue reactions if the set operation resulted in a value change
    // array 'length' property is an exception from this, because of it's exotic nature


    if (key === 'length' || value !== obj[key]) {
      queueReactionsForKey(obj, key);
      queueReactionsForKey(obj, ENUMERATE);
    }

    return Reflect.set(obj, key, value, receiver);
  }

  function deleteProperty(obj, key) {
    // only queue reactions for non symbol keyed property delete which resulted in an actual change
    if (typeof key !== 'symbol' && key in obj) {
      queueReactionsForKey(obj, key);
      queueReactionsForKey(obj, ENUMERATE);
    }

    return Reflect.deleteProperty(obj, key);
  }

  function queueReactionsForKey(obj, key) {
    // register a new reaction running task, if there are no reactions queued yet
    if (!queuedReactions.size) {
      nextTick(runQueuedReactions);
    } // iterate and queue every reaction, which is triggered by obj.key mutation


    iterateReactionsForKey(obj, key, queueReaction);
  }

  function queueReaction(reaction) {
    queuedReactions.add(reaction);
  }

  function runQueuedReactions() {
    queuedReactions.forEach(runReaction);
    queuedReactions.clear();
  } // set the reaction as the currently running one
  // this is required so that we can create (observable.prop -> reaction) pairs in the get trap


  function runReaction(reaction) {
    try {
      runningReaction = reaction;
      reaction();
    } finally {
      // always remove the currently running flag from the reaction when it stops execution
      runningReaction = undefined;
    }
  } // do not bind these, they should not be directly invoked or passed as callbacks by the user


  var reactInternals = new Set(['constructor', 'render', 'componentWillMount', 'componentDidMount', 'componentWillReceiveProps', 'shouldComponentUpdate', 'componentWillUpdate', 'componentDidUpdate', 'componentWillUnmount']); // bind the methods from proto to the passed context object and assign them to the context

  function autoBind(context, proto, isReact) {
    var _iterator = _createForOfIteratorHelper(Object.getOwnPropertyNames(proto)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var key = _step.value;
        var value = proto[key];

        if (typeof value === 'function' && !(isReact && reactInternals.has(key))) {
          context[key] = value.bind(context);
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  var REACTIVE_RENDER = Symbol('reactive render');

  function easyComp(Comp) {
    if (typeof Comp !== 'function') {
      throw new TypeError('easyComp expects a component as argument.');
    } // wrap stateless components in a class


    if (isStatelessComp(Comp)) {
      Comp = statelessToStatefulComp(Comp);
    } else if (hasComponentShouldUpdate(Comp)) {
      // shouldComponentUpdate is optimized by easyState, overwriting it would add zero or less value
      throw new Error('easyState optimizes shouldComponentUpdate, do not implement it.');
    }

    return toReactiveComp(Comp);
  }

  function isStatelessComp(Comp) {
    return !(Comp.prototype && Comp.prototype.render) && !react.Component.isPrototypeOf(Comp);
  }

  function statelessToStatefulComp(StatelessComp) {
    var _class, _temp;

    return _temp = _class = /*#__PURE__*/function (_react$Component) {
      _inherits(StatefulComp, _react$Component);

      function StatefulComp() {
        _classCallCheck(this, StatefulComp);

        return _possibleConstructorReturn(this, _getPrototypeOf(StatefulComp).apply(this, arguments));
      }

      _createClass(StatefulComp, [{
        key: "render",
        // call the original function component inside the render method
        // proxy react specific static variables to the stateful component
        // from the stateless component
        value: function render() {
          return StatelessComp.call(this, this.props, this.context);
        }
      }]);

      return StatefulComp;
    }(react.Component), _class.displayName = StatelessComp.displayName || StatelessComp.name, _class.contextTypes = StatelessComp.contextTypes, _class.propTypes = StatelessComp.propTypes, _class.defaultProps = StatelessComp.defaultProps, _temp;
  }

  function hasComponentShouldUpdate(Comp) {
    return typeof Comp.prototype.shouldComponentUpdate === 'function';
  }

  function toReactiveComp(Comp) {
    var _class2, _temp2; // return a HOC which overwrites render, shouldComponentUpdate and componentWillUnmount
    // it decides when to run the new reactive methods and when to proxy to the original methods


    return _temp2 = _class2 = /*#__PURE__*/function (_Comp) {
      _inherits(EasyHOC, _Comp);

      // proxy react specific static variables to the HOC from the component
      function EasyHOC(props) {
        var _this;

        _classCallCheck(this, EasyHOC);

        _this = _possibleConstructorReturn(this, _getPrototypeOf(EasyHOC).call(this, props)); // auto bind non react specific original methods to the component instance

        autoBind(_assertThisInitialized(_assertThisInitialized(_this)), Comp.prototype, true); // turn the store into an observable object, which triggers rendering on mutations

        if (typeof _this.store === 'object' && _this.store !== null) {
          _this.store = observable(_this.store);
        } else if ('store' in _assertThisInitialized(_assertThisInitialized(_this))) {
          throw new TypeError('component.store must be an object');
        }

        return _this;
      }

      _createClass(EasyHOC, [{
        key: "render",
        value: function render() {
          var _this2 = this;

          // if it is the first direct render from react call there is no reactive render yet
          if (!this[REACTIVE_RENDER]) {
            var result; // create a reactive render, which is automatically called by easyState on relevant store mutations
            // the passed function is executed right away synchronously once by easyState

            this[REACTIVE_RENDER] = observe(function () {
              // if it is the first (synchronous) execution, call the original component's render
              // this is necessary because forceUpdate can not be called synchronously inside render functions
              if (!_this2[REACTIVE_RENDER]) {
                result = _get(_getPrototypeOf(EasyHOC.prototype), "render", _this2).call(_this2);
              } else {
                // if it is a later reactive, asynchronous execution - triggered by easyState - forceUpdate the original component
                // this is necessary, because calling render would require the result to be returned
                // which is not possible from this asynchronous context
                _get(_getPrototypeOf(EasyHOC.prototype), "forceUpdate", _this2).call(_this2);
              }
            }); // return the result from super.render() inside the reactive render on the first render execution

            return result;
          } else {
            // return the original component's render result on direct calls from react
            return _get(_getPrototypeOf(EasyHOC.prototype), "render", this).call(this);
          }
        } // react should trigger updates on prop changes, while easyState handles store changes

      }, {
        key: "shouldComponentUpdate",
        value: function shouldComponentUpdate(nextProps) {
          var props = this.props;
          var keys = Object.keys(props);
          var nextKeys = Object.keys(nextProps); // component should update if the number of its props changed

          if (keys.length !== nextKeys.length) {
            return true;
          } // component should update if any of its props changed value


          for (var _i = 0, _keys = keys; _i < _keys.length; _i++) {
            var key = _keys[_i];

            if (props[key] !== nextProps[key]) {
              return true;
            }
          } // do not let react update the comp otherwise, leave store triggered updates to easyState


          return false;
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          // clean up memory used by easyState
          unobserve(this[REACTIVE_RENDER]); // also call user defined componentWillUnmount to allow the user
          // to clean up additional memory

          if (_get(_getPrototypeOf(EasyHOC.prototype), "componentWillUnmount", this)) {
            _get(_getPrototypeOf(EasyHOC.prototype), "componentWillUnmount", this).call(this);
          }
        }
      }]);

      return EasyHOC;
    }(Comp), _class2.displayName = Comp.displayName || Comp.name, _class2.contextTypes = Comp.contextTypes, _class2.propTypes = Comp.propTypes, _class2.defaultProps = Comp.defaultProps, _temp2;
  }

  function easyStore(store) {
    if (typeof store !== 'object' || store === null) {
      throw new TypeError('easyStore expects an object as argument');
    } // create an observable object from the passed store
    // and bind all of its methods to the created observable


    var observableStore = observable(store);
    autoBind(observableStore, store, false);
    return observableStore;
  }

  exports.easyComp = easyComp;
  exports.easyStore = easyStore;
  Object.defineProperty(exports, '__esModule', {
    value: true
  });
});